module.exports = __webpack_public_path__ + "static/media/NEMA8.48bedfb7.pdf";